const values = [
  { label: "Adecco", value: 1 },
  { label: "Usuaria", value: 2 },
  { label: "Compartido", value: 3 },
];

export default values;
